import { Component, AfterViewInit, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ADN_PLUS, EntityField } from '../../models';
import { HttpService } from '../../services';
import { CtFilterContainerComponent } from '../ct-filter-container/ct-filter-container.component';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'lib-ct-custom-select',
  templateUrl: './ct-custom-select.component.html',
  styleUrls: ['./ct-custom-select.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
  }
})

export class CtCustomSelect extends CtrlBaseComponent implements AfterViewInit, OnInit  {


  @ViewChild('selectContainer') selectContainer: ElementRef;

  public optionsContainer : Element;
  public arrow : Element;
  public selectLabel : Element;
  public subContainerfocus : Element;
  private parentFilterContainer : CtFilterContainerComponent;
  public options: any[] = [];
  public selectedAdn : ADN_PLUS;
  private adnList: ADN_PLUS[] = [];
  private fieldValue: string;
  private fieldText: string;
  private optionsList: string;
  public defaultOption : string;
  public defaultValue : string;
  public isOptionSelected : boolean = false;
  private readOnly: boolean = false;
  private isSelectOpen : boolean = false;
  public isLoading : boolean = false;
  private isValid : boolean = true;
  private requiredMessage: string;
  private required: boolean = false;
  private isInSideFilterContainer : boolean = false;
  private onClickCloseIcon:boolean = false;
  public showSortDescIcon:boolean = false;
  public showSortAscIcon:boolean = false;
  public showSortCloseIcon: boolean = false;

  private maxItemsVisible : number; 

  constructor() { 
    super();
  }

  ngOnInit():void{
    super.ngOnInit();
    if(this.getListenedComponentId() && this.getListenedComponentId().length > 0){
      this.setIsInSideFilterContainer(true);
    }else{
      this.setIsInSideFilterContainer(false);
    }
    this.showSortDescIcon = true;
  }

  ngAfterViewInit() {   
    this.optionsContainer = document.querySelector('#optionsContainer_'+this.getId());
    this.arrow = document.querySelector('#arrow_'+this.getId());
    this.selectLabel = document.querySelector('#selectLabel_'+this.getId());
    this.subContainerfocus = document.querySelector('#subContainerfocus_'+this.getId());
    this.loadListCode();
  }

  /*gets the list of options for the select. */
  private loadListCode(): void {
    if (this.optionsList !== undefined && this.optionsList !== null && this.optionsList !== "null") {
        if (this.optionsList && this.optionsList !== "") {
            let list = this.getListFromCache(this.optionsList);
            if (list) {
                this.options = list;
                this.setDefaultOptionToList();
            } else {
                this.isLoading = true;
                this.httpService.scheduleRequest('get', HttpService.ENDPOINT + '/api/List/' + this.optionsList, (response) => {
                    if (typeof (response) === 'string') {
                      response = JSON.parse(response);
                    }

                    this.adnList = response;
                    let isStatic = false;

                    if (this.adnList && this.adnList.length > 0){
                      isStatic = this.utilService.getStringAttribute('@IS_STATIC', this.adnList[0].ArrayEntities.List) === 'Y';
                    }

                    this.options = this.utilService.convertAdnToSelectOptions(response, this.fieldValue, this.fieldText);
                    this.setListToCache(this.optionsList, this.options, isStatic);
                    this.setDefaultOptionToList();
                    setTimeout(() => {
                        this.isLoading = false;
                    });
                }, null, null, this.getId(), true, this.optionsList);
            }
        }
        this.setDefaultValueToAdn();
    } else {
        this.options = this.utilService.convertAdnToSelectOptions(this.adnList, this.fieldValue, this.fieldText);
        this.setDefaultOptionToList();
        this.setDefaultValueToAdn();
        setTimeout(() => {
            this.isLoading = false;
        });
    }

    setTimeout(() => {
        this.isLoading = false;
    },5000);
  }

  /**
   * It gets a list from the cache
   * @param {string} listCode - The code of the list you want to get.
   * @returns A list of values.
   */
  private getListFromCache(listCode: string): any[] {
    let listStr = localStorage.getItem(listCode);
    let isStatic = listStr !== null;
    let list = null;

    if (!listStr){
      listStr = sessionStorage.getItem(listCode);
    }

    if (listStr) {
        list = JSON.parse(listStr);
        let diffTime = Math.abs(new Date().getTime() - new Date(list.created).getTime());
        if (isStatic){
          diffTime = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); /*dias*/
        } else {
          diffTime = Math.ceil(diffTime / (1000 * 60)); /*minutos*/
        }

        if (diffTime <= (isStatic ? 7 /*dias*/ : 5 /*minutos*/)){
          list = list.values;
        } else {
            localStorage.removeItem(listCode);
            sessionStorage.removeItem(listCode);
            list = null;
        }
    }
    return list;
  }

  /**
   * It takes a list code, a list of values, and a boolean value indicating whether the list is static or
   * not. If the list is static, it will be stored in local storage, otherwise it will be stored in
   * session storage
   * @param {string} listCode - The code of the list you want to get.
   * @param {any[]} listValues - The list of values to be cached.
   * @param {boolean} [isStatic=false] - If true, the list will be cached in localStorage. If false, it
   * will be cached in sessionStorage.
   */
  private setListToCache(listCode: string, listValues: any[], isStatic: boolean = false): void {
    if (isStatic){
      localStorage.setItem(listCode, JSON.stringify({ values: listValues, created: new Date().toDateString() }));
    }
    else {
      sessionStorage.setItem(listCode, JSON.stringify({ values: listValues, created: new Date().getTime() }));
    }
  }

  /**
   * It takes the option that was clicked on and creates a new ADN_PLUS object with the
   * selected option
   * @param {any} option - any - this is the option that was selected.
   */
  public onSelectOptionClick(option : any, executesSearch : boolean = true): void {
    if(!executesSearch) return;
    this.manageSelectClickWhenIsOpen();
    this.isOptionSelected = true;
    if(this.isInSideFilterContainer) {
      this.showSortCloseIcon = true;
      this.showSortDescIcon = false;
    }
    this.executeOnSelectAction(option, executesSearch);
  }

  public executeOnSelectAction(option: any, executesSearch: boolean) {
    if(!executesSearch) return;
    this.checkOptionSelected(option.text);
    this.checkSelectValidity();
    this.setOptionToSelect(option);
  }

  private checkSelectValidity() {
    if(this.getIsValid()) return;
    this.subContainerfocus.classList.remove('th-bg-input');
    this.subContainerfocus.classList.add('th-bg-input-alert');
    this.subContainerfocus.classList.add('th-input-alert');
  }

  private setOptionToSelect(option: any) {
    this.selectLabel.innerHTML = option.text;
    this.selectedAdn = new ADN_PLUS();
    this.selectedAdn.ArrayEntities.List.push(new EntityField(option.text,option.value,1));
    this.executeSearch();
  }

  public onSelectClick(): void {
    if(this.isInSideFilterContainer) this.manageFilterContainerSelectClick();
    else this.manageSelectClick();
  }

  private manageSelectClick() {
    if(this.isSelectOpen) this.manageSelectClickWhenIsOpen();
    else this.manageSelectClickWhenIsClosed();
  }

  private manageSelectClickWhenIsOpen() {
    this.disableIcon();
    this.showSortDescIcon = true;
    this.disableStyleSelected(); 
    this.isSelectOpen = false;
  }

  private manageSelectClickWhenIsClosed() {
    this.disableIcon();
    this.showSortAscIcon = true;
    this.enableStyleSelected();
    this.setIsValid(true);
    this.subContainerfocus.classList.remove('th-bg-input-alert');
    this.subContainerfocus.classList.remove('th-bg-alert');
    this.subContainerfocus.classList.remove('th-input-alert');
    this.isSelectOpen = true;
  }

  public resetSelectAdnValue() {
    this.setDefaultValueToAdn();
    this.selectLabel.innerHTML = this.selectedAdn.ArrayEntities.List[0].Name;
    this.executeSearch();
    this.isOptionSelected = false; 
  }

  private manageFilterContainerSelectClick() {
    if(this.isSelectOpen) this.manageFilterContainerSelectClickWhenIsOpen();
    else this.manageFilterContainerSelectClickWhenIsClosed();
  }

  public manageFilterContainerSelectClickWhenIsClosed() {
    if(this.isOptionSelected) {
      this.resetSelectAdnValue();
      this.showSortCloseIcon = false;
      this.showSortDescIcon = true;
      this.executeOnSelectAction(this.getFirstOption(), false);
    }
    else this.manageSelectClickWhenIsClosed();
  }

  private manageFilterContainerSelectClickWhenIsOpen() {
    this.manageSelectClickWhenIsOpen();
  }

  private enableStyleSelected(): void {
    this.optionsContainer.classList.toggle('active');
    this.subContainerfocus.classList.add('bs-without-bottom-radius');
    this.subContainerfocus.classList.add('th-input-border-focus');
  }

  private disableStyleSelected(): void {
    this.subContainerfocus.classList.remove('bs-without-bottom-radius');
    this.subContainerfocus.classList.remove('th-input-border-focus');
    this.optionsContainer.classList.remove('active'); 

  }

  private disableIcon(): void {
    this.showSortAscIcon = false;
    this.showSortDescIcon = false;
    this.showSortCloseIcon = false;
  }

  private setDefaultOptionToList(): void {
    if(this.getDefaultOption() !== ''){
      this.options.unshift({ text : this.getDefaultOption(), value : this.getDefaultValue() });
      return;
    }
  }

  public checkOptionSelected(optionSelected: any) {
    if (this.getRequired() == true) {
      if (this.getDefaultOption() && this.getDefaultOption() === optionSelected) {
        this.setIsValid(false);
        return;
      }
      if (optionSelected.length == 0 || optionSelected == "null") {
        this.setIsValid(false);
        return;
      }
    }
    else {
      this.setIsValid(true);
    }
  }

  private executeSearch(): void {
    this.parentFilterContainer = this.utilService.getComponentRef(this.getListenedComponentId());
    if(this.parentFilterContainer) this.parentFilterContainer.receiveDataFromFilterSelect(this.utilService.getComponentRef(this.getId()));
  }

  private setDefaultValueToAdn(): void {
    this.selectedAdn = new ADN_PLUS();
    if(this.defaultOption !== ''){
      this.selectedAdn.ArrayEntities.List.push(new EntityField(this.getDefaultOption(),this.getDefaultValue(),1));
    }
    if(this.options.length > 0){
      this.selectedAdn.ArrayEntities.List.push(new EntityField(this.options[0].text,this.options[0].value,1));
    }
  }

  getDropdownMaxHeight(): any {
    if (this.getMaxItemsVisible() && this.showSortAscIcon == true) {
      return {'max-height.px': this.getMaxItemsVisible() * 40};
    }
    return {};
  }

  public getMaxWidth(): number {
    if(!this.selectContainer) return;
    return this.selectContainer.nativeElement.offsetWidth;
  }

  getFieldValue(): string { return this.fieldValue }
  getFieldText(): string { return this.fieldText }
  getOptionsList(): string { return this.optionsList }
  getIsOptionSelected(): boolean { return this.isOptionSelected }
  getIsSelectOpen():  boolean { return this.isSelectOpen }
  getDefaultOption(): string { return this.defaultOption }
  getFirstOption(): string {return this.options[0]}
  getValue(): string { return this.selectedAdn.ArrayEntities.List[0].Value }
  getAdnValue(): ADN_PLUS { return this.selectedAdn }
  getInputDataType() : number { return 1}
  getDefaultValue(): string { return this.defaultValue; }
  getReadOnly(): boolean { return this.readOnly }
  getIsValid(): boolean { return this.isValid }
  getRequiredMessage(): string { return this.requiredMessage }
  getRequired(): boolean { return this.required }
  getIsInSideFilterContainer(): boolean { return this.isInSideFilterContainer }
  getMaxItemsVisible(): number {return this.maxItemsVisible}

  setRequired(required: boolean): void { this.required = required }
  setIsValid(isValid: boolean) { this.isValid = isValid }
  setRequiredMessage(requiredMessage: string): void { this.requiredMessage = requiredMessage }
  setFieldValue(fieldValue: string): void { this.fieldValue = fieldValue }
  setFieldText(fieldText: string): void { this.fieldText = fieldText }
  setOptionsList(optionsList: string) { this.optionsList = optionsList }
  setIsOptionSelected(isOptionSelected : boolean): void { this.isOptionSelected = isOptionSelected}
  setIsSelectOpen(isSelectOpen : boolean): void { this.isSelectOpen = isSelectOpen}
  setDefaultOption(defaultOption : string) : void { this.defaultOption = defaultOption }
  setDefaultValue(defaultValue : string) : void { this.defaultValue = defaultValue }
  setReadOnly(readOnly : boolean) : void { this.readOnly = readOnly }
  setIsInSideFilterContainer(isInSideFilterContainer : boolean) : void { this.isInSideFilterContainer = isInSideFilterContainer }
  setMaxItemsVisible(maxItemsVisible: number) : void {this.maxItemsVisible = maxItemsVisible}
}